import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import { InputTextarea } from 'primereact/inputtextarea'

interface CancelReasonModalProps {
  visible: boolean
  onHide: () => void
  reason: string
}

export default function CancelReasonModal({ visible, onHide, reason }: CancelReasonModalProps) {
  const header = (
    <span style={{ color: '#B27668', fontWeight: 600, fontSize: '1.25rem' }}>
      Razón de cancelación
    </span>
  )

  const footer = (
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', paddingBottom: '0.75rem' }}>
    </div>
  )

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={header}
      footer={footer}
      style={{ width: '480px', borderRadius: '12px', overflow: 'hidden' }}
      closable
      closeIcon='pi pi-times'
      pt={{
        closeButton: {
          style: { color: '#3CB8BA' },
        },
        footer: {
          style: { background: '#f5f5f5', borderTop: '1px solid #e5e7eb', padding: '1rem 1.5rem 1.5rem' }
        },
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <InputTextarea
          value={reason}
          rows={4}
          style={{
            width: '100%',
            resize: 'none',
            border: '1px solid #c2cbd6',
            borderRadius: '4px',
          }}
      />
        <p style={{ margin: 0, color: '#374151', fontSize: '0.95rem' }}>
          Razón que fue informada al momento de la cancelación
        </p>
      </div>
    </Dialog>
  )
}
